const authProvider = {
  login: ({ username, password }) =>  {
    // const request = new Request('https://localhost:8443/api/login_check', {
    const request = new Request('https://api.miamfoods.lamanufacturedunet.fr/api/login_check', {
      method: 'POST',
      body: JSON.stringify({ email: username, password }),
      headers: new Headers({ 'Content-Type': 'application/json' }),
    });
    return fetch(request)
      .then(response => {
        if (response.status < 200 || response.status >= 300) {
          throw new Error(response.statusText);
        }
        return response.json();
      })
      .then(({ token }) => {
        localStorage.setItem('token', token);
        localStorage.setItem('token_is_new', 'true');
        window.location.replace('/');
      });
  },
  logout: () => {
    localStorage.removeItem('token');
    return Promise.resolve();
  },
  checkError: (error) => {
    const status = error.status;
    if (status === 401 || status === 403) {
      localStorage.removeItem('token');
      return Promise.reject();
    }
    return Promise.resolve();
  },
  checkAuth: () => localStorage.getItem('token')
    ? Promise.resolve()
    : Promise.reject({ redirectTo: '/no-access' }),
  getPermissions: () => {
    // const role = localStorage.getItem('permissions');
    window.localStorage.removeItem("token_is_new");
    const role = 'ROLE_ADMIN';
    return role ? Promise.resolve(role) : Promise.reject();
  }
};

export default authProvider;
